import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';

import { VrcDataService } from './vrc-data.service';
import { VrcStorageService } from './vrc-storage.service';
function getLookups(srvc: VrcDataService, st: VrcStorageService): Observable<boolean> {

    return forkJoin([
        srvc.getInterests().pipe(
            take(1),
            map(x => {
                st.interestsLookup = x;
                st.sessionId = null;
                return true;
            }),
            catchError((err: HttpErrorResponse) => {
                console.log(err);
                return of(false);
            })),
        srvc.getAdvertisingPermissions().pipe(
            take(1),
            map(x => {
                st.advertisingPermissions = x;
                st.sessionId = null;
                return true;
            }),
            catchError((err: HttpErrorResponse) => {
                console.log(err);
                return of(false);
            })),
        srvc.getProducts().pipe(
            take(1),
            map(x => {
                st.products = x;
                st.sessionId = null;
                return true;
            }),
            catchError((err: HttpErrorResponse) => {
                console.log(err);
                return of(false);
            }))]).pipe(
                switchMap(() => of(true)),
                catchError((err: HttpErrorResponse) => {
                    console.log(err);
                    return of(false);
                }));
};
export const vrcLookupResolver: ResolveFn<boolean> =
    () => {
        const _srvc = inject(VrcDataService);
        const _st = inject(VrcStorageService);

        if (!_st.interestsLookup || !_st.advertisingPermissions || !_st.products) {
            return getLookups(_srvc, _st);
        }
        return true;
    };


